module.exports = __webpack_public_path__ + "img/f4-1.034f129c.png";